module.exports = __webpack_public_path__ + "img/login-logo.94255416.png";